import React from 'react'
import Logo from "../../Logo"
import MenuInicioSuscrito from '../../../pages/inicioSuscrito/MenuInicioSuscrito'
import Redes from '../../Redes'
import Footer from "../../../Reutilizables/Footer"
import "../../../../styles/registrado/noticias/slideNoticias2.css"

function SlideNoticias2() {
  return (
    <>
      <Logo />
      <MenuInicioSuscrito />
      <Redes />
      <div className='body-slideNoticias2'>
        <section className='section-slideNoticias2'>
          <h3 className='subtittle-slideNoticias2'>¿Qué es el IVA o impuesto sobre el valor añadido?</h3>
          <div className='text-slideNoticias2'>
            <p className='paragrhap-slideNoticias2'>
              El IVA es un impuesto indirecto que se entrega al gobierno en cada etapa de la producción de un artículo, es decir, 
              cada vez que se genera un valor añadido.
            </p>
            <p className='paragrhap-slideNoticias2'>
              Se considera un sistema de imposición indirecta sobre la venta de bienes y servicios a los consumidores finales, 
              es decir, en pocas palabras el IVA es un impuesto sobre el consumo que se paga cada vez que compramos un bien o un 
              servicio.
            </p>
            <p className='paragrhap-slideNoticias2'>
              Las empresas que son las encargadas de registrar el IVA cuentan en su contabilidad con dos asientos distintos. 
              En el primer asiento apuntan el IVA cobrado por la venta de sus bienes y servicios, lo que se denomina IVA Repercutido y 
              en el segundo asiento apuntan el IVA que han pagado sobre sus compras y gastos, lo que se denomina IVA soportado.
            </p>
            <p className='paragrhap-slideNoticias2'>
              Para no pagar dos veces este impuesto, las empresas a finales del año restan al IVA repercutido el IVA soportado. 
              En el caso de que salga más IVA repercutido que soportado, pagarán la diferencia a las autoridades fiscales del país. 
              En cambio sí tras realizar la liquidación la empresa cuenta con más IVA soportado que repercutido, será la autoridad 
              fiscal del país la que devuelva la diferencia a la empresa.
            </p>
            <p className='paragrhap-slideNoticias2'>
              Esto hace que el IVA no sea un coste para las propias empresas, sino que recae sobre el consumidor final, 
              siendo el papel único de las empresas el de cobrarlo a los consumidores y reintegrarse en el gobierno.
            </p>
          </div>
        </section>

        <section className='section-slideNoticias2'>
          <h3 className='subtittle-slideNoticias2'>Ejemplo de cómo funciona el IVA</h3>
          <div className='text-slideNoticias2'>
            <p className='paragrhap-slideNoticias2'>
              Vamos a visualizar el concepto de IVA a través del siguiente ejemplo aplicando un tipo impositivo general del 10 %.
            </p>
            <p className='paragrhap-slideNoticias2'>
              Un productor. Digamos que se trata de un autónomo que camina por la playa recogiendo en una 
              bolsa diferentes conchas marinas que se va encontrando por el camino y las lleva a pie a un fabricante de joyas.
            </p>
            <p className='paragrhap-slideNoticias2'>
              El autónomo envía una factura al fabricante por la mercancía de 100.000 pesos y cobra un IVA de 10.000 pesos, con lo que el total 
              de la factura es de 110.000 pesos.
            </p>
            <p className='paragrhap-slideNoticias2'>
              El fabricante de joyas convierte las conchas marinas en hermosas joyas y las vende por 200.000 pesos a un mayorista. 
              Además de los 200.000 pesos de la mercancía, cobra 20.000 pesos en concepto de IVA, por lo que el total de la factura 
              es de 220.000 pesos.
            </p>
            <p className='paragrhap-slideNoticias2'>
              A continuación el mayorista se encargará de distribuir estas joyas repartiéndolas a diversos minoristas del país. 
              En total consigue venderlas por 300.000 pesos generando un IVA de 30.000 pesos por lo que el total de la factura es 
              de 330.000 pesos.
            </p>
            <p className='paragrhap-slideNoticias2'>
              Finalmente el minorista vende estas joyas a los consumidores finales por un valor de 400.000 pesos, cobrando un IVA de 40.000 pesos. 
              Por lo que los consumidores han pagado un precio final de 440.000 pesos.
            </p>
            <p className='paragrhap-slideNoticias2'>
              Como hemos visto el valor se ha ido añadiendo continuamente a lo largo de la cadena de producción ya que cada empresa 
              aporta su granito de experiencia y conocimientos específicos, lo que hace que cada una venda a un precio superior al que 
              compró la mercancía.
            </p>
            <h3 className='subtittle-slideNoticias2'>
              Ahora bien, si nos fijamos en el IVA, así es como funcionaria su recaudación en las diferentes etapas:
            </h3>
            <p className='paragrhap-slideNoticias2'>
              <ul className='ul-slideNoticias2'>
                <li>
                  El productor ha cobrado al fabricante 10.000 pesos de IVA repercutido y no tiene IVA soportado, 
                  por lo que liquida 10.000 pesos mediante un pago al gobierno.
                </li>
                <li>
                  El fabricante ha cobrado 20.000 pesos de IVA repercutido al mayorista y tiene 10.000 pesos de IVA soportado, 
                  por lo que paga un importe neto de 10.000 pesos al gobierno.
                </li>
                <li>
                  El mayorista tiene 30.000 pesos de IVA repercutido y 20.000 pesos de IVA soportado, por lo que paga otros 10.000 pesos 
                  netos a la Administración.
                </li>
                <li>
                  El minorista tiene 40.000 pesos de IVA repercutido y 30.000 pesos de IVA soportado, por lo que los últimos 10.000 pesos 
                  netos de IVA van al gobierno.
                </li>
              </ul>
            </p>
            <p className='paragrhap-slideNoticias2'>
              Esto hace un total de cuatro etapas de 10.000 pesos de IVA en cada una que equivalen a un total de 40.000 pesos que han ido a 
              parar a las arcas del estado.
            </p>
            <p className='paragrhap-slideNoticias2'>
              Como se puede ver, el IVA es realmente un impuesto que repercute en los consumidores, ya que son ellos los que pagan en 
              última instancia los 40.000 pesos que se incluyen en el precio de venta al público de 440.000 pesos.
            </p>
            <p className='paragrhap-slideNoticias2'>
              Por tanto, como ya hemos dicho antes el IVA no es un coste para las propias empresas, sino que éstas lo recaudan y lo 
              pagan al estado a lo largo de las distintas etapas de la cadena de valor.
            </p>
          </div>
        </section>

        <section className='section-slideNoticias2'>
          <h3 className='subtittle-slideNoticias2'>¿Cómo funciona el IVA en un contexto internacional? ¿Cómo debe aplicarse?</h3>
          <div className='text-slideNoticias2'>
            <p className='paragrhap-slideNoticias2'>
              En la Unión Europea, por ejemplo, la norma principal es que el lugar de prestación de los servicios de empresa a empresa 
              prestados dentro de la UE será el país donde esté establecido el destinatario de los servicios.
            </p>
            <p className='paragrhap-slideNoticias2'>
              ¿Significa eso que si trabajas en España y vendes a todos los países de la unión europea como puede ser Italia, Alemania, 
              Francia, debes inscribirte en el IVA de todos estos países en los que has prestado tus servicios?
            </p>
            <p className='paragrhap-slideNoticias2'>
              Afortunadamente para la mayoría de las empresas no, ya que hay una solución para esta situación y es el llamado IVA intracomunitario.
            </p>
            <p className='paragrhap-slideNoticias2'>
              En el IVA intracomunitario, no se produce IVA en la propia factura. De esta forma el destinatario de la factura liquida por sí mismo el 
              IVA del país en su declaración de IVA mensual o trimestral, y deduce esa misma cantidad en esa declaración de IVA, lo que da lugar a una 
              carga de IVA de cero, pero con dos partidas.
            </p>
            <p className='paragrhap-slideNoticias2'>
              Tanto el proveedor como el cliente presentan un formulario separado de las transacciones transfronterizas, 
              detallando en este formulario el número de IVA de la «contraparte» y el importe.
            </p>
            <p className='paragrhap-slideNoticias2'>
              Esto simplifica enormemente la gestión administrativa de las empresas ya que no tendrían que pagar el IVA en todos los países 
              en los que vende bienes o presta servicios si no solo en su país.
            </p>
          </div>
        </section>
      </div>
      <Footer />
    </>
  )
}

export default SlideNoticias2
